import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
// import registerServiceWorker from "./registerServiceWorker";
import "font-awesome/css/font-awesome.min.css";
import "./index.scss";
import Spinner from "./components/spinner/spinner";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';
// const cacheBust = Date.now(); // generates a unique value for cache busting
// const cssUrl = `/static/css/main.css?cacheBust=${cacheBust}`;
// const jsUrl = `/static/js/main.js?cacheBust=${cacheBust}`;

// // add a link tag for our CSS file
// const link = document.createElement('link');
// link.href = cssUrl;
// link.rel = 'stylesheet';
// document.head.appendChild(link);

// // add a script tag for our JS file
// const script = document.createElement('script');
// script.src = jsUrl;
// document.head.appendChild(script);

const LazyApp = lazy(() => import("./app/app"));
ReactDOM.render(
   <Suspense fallback={<Spinner />}>
      <LazyApp />
   </Suspense>,
   document.getElementById("root")
);
// registerServiceWorker();
